import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Table from '../_Components/AdminTable'
import { Link } from 'react-router-dom'
import { call } from '../../Methods'
import { use } from '../../Helpers'

function _Users () {
  const pageTitle = 'Users'
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([])

  const defaultParameters = {
    statusId: '',
    pageNumber: 1,
    pageSize: 10,
    sort: 'desc'
  }

  const userDefinedParameters = JSON.parse(
    localStorage.getItem('tpp_userSettings')
  ).searchSettings
  let _parameters = {}
  Object.assign(
    _parameters,
    defaultParameters,
    userDefinedParameters.searchSettings
  )
  const [parameters, setParameters] = useState(_parameters)
  
  let tableColumns = [
    {
      title: 'Email',
      property: 'email'
    },
    {
      title: 'Email',
      property: ['name','surname','phone','address'],
      mutate: values => {
        return (
          <div style={{textAlign: 'left'}}>
            <div>{values[0]} {values[1]}</div>
            <div><b>Phone:</b> {values[2]}, <b>Address:</b> {values[3]}</div>
          </div>
        )
      }
    },
    {
      title: 'Role',
      property: 'roleName',
      mutate:value=>{
        return (value=='admin'? <span><b>{value}</b></span>: <span>{value}</span>)
      }
    },
    {
      title: 'Status',
      property: ['statusId','statusName'],
      type: 'label',
      mutate: values => {
        return (
          <span style={{ backgroundColor: use.colorsByValues(values[0]) }}>
            {values[1]}
          </span>
        )
      }
    },
    {
      title: 'Actions',
      property: 'id',
      type: 'actions-list',
      mutate: value => {
        return (
          <>
            <Link to={`/admin/user/${value}`}>
              <img
                className='action-icon'
                title={'Edit'}
                src={'/Icons/edit.png'}
              />
            </Link>
          </>
        )
      }
    }
  ]

  const getData = async parameters => {
    const _users = await call.forLoggedUser.user.getUsers({})
    if(_users.success){
      setLoading(false);
      return _users
    }
    return false
  }


  return (
    <React.Fragment>
      <h3 className='page-title'>{pageTitle}</h3>
      { <Table
        parameters={parameters}
        columns={tableColumns}
        loading={loading}
        getMethod={() => getData(parameters)}
        addNew={{ enabled: true, url: '/admin/user/add' }}
      />}
    </React.Fragment>
  )
}

export default _Users
